import React from 'react';
import { colors } from '@styles/core-styles/theme';

export const DeploymentIcon: React.FC<{
	color?: string;
	width?: string;
	height?: string;
}> = ({ color = colors.orange, width = '100%', height = '100%' }) => {
	const secondaryColor = color === colors.white ? colors.orange : colors.white;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 147 111"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.12315 65.9384H17.4616V101.769H5.96931C5.40765 101.769 4.8515 101.659 4.3326 101.444C3.8137 101.229 3.34221 100.914 2.94506 100.517C2.54792 100.119 2.23288 99.6479 2.01794 99.129C1.80301 98.6101 1.69238 98.0539 1.69238 97.4923V70.3692C1.69238 69.1941 2.15919 68.0671 2.99013 67.2362C3.82106 66.4053 4.94804 65.9384 6.12315 65.9384V65.9384Z"
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M56.3076 63.8462C57.678 63.4764 59.1219 63.4764 60.4922 63.8462L98.9538 74.1539C99.9621 74.4216 100.908 74.8859 101.736 75.52C102.564 76.1541 103.259 76.9456 103.781 77.849C104.303 78.7524 104.641 79.7499 104.776 80.7844C104.911 81.8188 104.841 82.8698 104.569 83.8769C104.295 84.8887 103.823 85.8362 103.182 86.6651C102.54 87.494 101.741 88.1879 100.83 88.7068C99.9196 89.2258 98.9152 89.5597 97.8751 89.6892C96.8349 89.8187 95.7793 89.7414 94.7692 89.4616L66.8307 81.9231"
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M34.4768 58.1231H20.723C18.9217 58.1231 17.4614 59.5833 17.4614 61.3846V106.323C17.4614 108.124 18.9217 109.585 20.723 109.585H34.4768C36.2781 109.585 37.7383 108.124 37.7383 106.323V61.3846C37.7383 59.5833 36.2781 58.1231 34.4768 58.1231Z"
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M144.461 66.3539C143.955 65.42 143.266 64.5974 142.436 63.9346C141.605 63.2719 140.65 62.7825 139.627 62.4956C138.605 62.2087 137.534 62.13 136.481 62.2642C135.427 62.3984 134.41 62.7428 133.492 63.2769L104.354 79.3077C103.955 78.0979 103.267 77.0035 102.35 76.1189C101.434 75.2344 100.315 74.5863 99.0921 74.2308L60.1075 63.7385C58.8888 63.447 57.6185 63.447 56.3998 63.7385L37.7383 67.8923V99.5539L46.769 102.769C48.2493 103.299 49.8124 103.559 51.3844 103.538L92.3383 103.323C94.395 103.309 96.4156 102.78 98.2152 101.785C108.154 96.1693 141.2 77.1693 141.2 77.1693C143.032 76.1337 144.394 74.431 145.001 72.4162C145.609 70.4013 145.415 68.2297 144.461 66.3539V66.3539Z"
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M129.523 1.15385H44.1848C42.4855 1.15385 41.1079 2.53143 41.1079 4.23077V53.8615C41.1079 55.5609 42.4855 56.9385 44.1848 56.9385H129.523C131.223 56.9385 132.6 55.5609 132.6 53.8615V4.23077C132.6 2.53143 131.223 1.15385 129.523 1.15385Z"
				fill={color}
				stroke={color}
				stroke-width="2"
				stroke-miterlimit="10"
			/>
			<path
				d="M86.8462 29.0461L97.6154 22.8308V35.2461L86.8462 41.4923V29.0461Z"
				stroke={secondaryColor}
				stroke-width="2"
				stroke-linejoin="round"
			/>
			<path
				d="M86.8464 29.0461L76.0771 22.8308V35.2461L86.8464 41.4923V29.0461Z"
				stroke={secondaryColor}
				stroke-width="2"
				stroke-linejoin="round"
			/>
			<path
				d="M97.6156 22.8308L86.8464 29.0462L76.0771 22.8308L86.8464 16.6L97.6156 22.8308Z"
				stroke={secondaryColor}
				stroke-width="2"
				stroke-linejoin="round"
			/>
		</svg>
	);
};
